@if ((!id || dataObject) && metadata) {
  <div class="dashboard">
    @if (!editingInOverlay) {
      @if (attachments.length > 0) {
        <div class="dashboard__main">
          <div class="doc-split">
            <div class="doc-split__tabs">
              <button type="button" class="doc-split__tab" [class.doc-split__tab--active]="activeDocView === 'data'" (click)="activeDocView = 'data'">Gegevens</button>
              <button type="button" class="doc-split__tab" [class.doc-split__tab--active]="activeDocView === 'document'" (click)="activeDocView = 'document'">Document</button>
            </div>
            <div class="doc-split__panels">
              <div class="doc-split__panel doc-split__panel--data" [class.is-hidden]="activeDocView !== 'data'">
                @if (dataObject) {
                  <ng-container *ngTemplateOutlet="dashboardButtons"></ng-container>
                }
                @for (layout of mainLayouts; track layout) {
                  <mrd-layout-section
                    #sectionEl
                    [accessControlEnabled]="accessControlEnabled"
                    [items]="layout.items"
                    [data]="dataRecord"
                    [locale]="locale"
                    [readOnly]="isViewer"
                    [me]="me"
                    [archetypes]="metadata.archetypes || []"
                    (mrdNavigate)="onMrdNavigate($any($event))"
                    (mrdDownload)="onMrdDownload($any($event))"
                    (mrdLoadImage)="onMrdLoadImage(sectionEl, $any($event))"
                    (mrdLoadObject)="onMrdLoadObject(sectionEl, $any($event))"
                    (mrdAttachments)="onMrdAttachments($any($event))"
                    (mrdLoadViewPage)="onMrdLoadViewPage(sectionEl, $any($event))"
                    (mrdLoadViewAggregations)="onMrdLoadViewAggregations(sectionEl, $any($event))"
                    (mrdLoadViewDistinct)="onMrdLoadViewDistinct(sectionEl, $any($event))"
                    (mrdSearch)="onMrdSearch(sectionEl, $any($event))"
                    (mrdViewAction)="onMrdViewAction($any($event))"
                    (mrdUpdateObject)="onMrdUpdateObject($any($event))"
                    (mrdDeleteObject)="onMrdDeleteObject($any($event))"
                    (mrdViewUpload)="onMrdViewUpload(sectionEl, $any($event))"
                    (mrdCreateObject)="onMrdCreateObject(sectionEl, $any($event))"
                    (mrdViewCheckCapabilities)="onMrdViewCheckCapabilities(sectionEl, $any($event))">
                  </mrd-layout-section>
                }
                @if (tabPages.length > 0) {
                  <div class="tabPage">
                    @for (layout of tabPages; track layout; let i = $index) {
                      <input type="radio" [id]="'tabPage' + i + '-' + tabGroupId" [name]="tabGroupId" [checked]="i === 0" class="tabPage__radio" (change)="onTabPageSelected(i)">
                      <label [for]="'tabPage' + i + '-' + tabGroupId" class="tabPage__label">{{ layout.label }}</label>
                      <div class="tabPage__content">
                        @if (visitedTabPages.has(i)) {
                          <mrd-layout-section
                            #sectionEl
                            [accessControlEnabled]="accessControlEnabled"
                            [items]="layout.items"
                            [data]="dataRecord"
                            [locale]="locale"
                            [readOnly]="isViewer"
                            [me]="me"
                            (mrdNavigate)="onMrdNavigate($any($event))"
                            (mrdDownload)="onMrdDownload($any($event))"
                            (mrdLoadImage)="onMrdLoadImage(sectionEl, $any($event))"
                            (mrdLoadObject)="onMrdLoadObject(sectionEl, $any($event))"
                            (mrdLoadViewPage)="onMrdLoadViewPage(sectionEl, $any($event))"
                            (mrdLoadViewAggregations)="onMrdLoadViewAggregations(sectionEl, $any($event))"
                            (mrdLoadViewDistinct)="onMrdLoadViewDistinct(sectionEl, $any($event))"
                            (mrdSearch)="onMrdSearch(sectionEl, $any($event))"
                            (mrdViewAction)="onMrdViewAction($any($event))"
                            (mrdUpdateObject)="onMrdUpdateObject($any($event))"
                    (mrdDeleteObject)="onMrdDeleteObject($any($event))"
                            (mrdViewUpload)="onMrdViewUpload(sectionEl, $any($event))"
                            (mrdCreateObject)="onMrdCreateObject(sectionEl, $any($event))"
                            (mrdViewCheckCapabilities)="onMrdViewCheckCapabilities(sectionEl, $any($event))">
                          </mrd-layout-section>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="doc-split__panel" [class.is-hidden]="activeDocView !== 'document'">
                <app-document-preview [attachments]="attachments"></app-document-preview>
              </div>
            </div>
          </div>
        </div>
      } @else {
        @for (layout of mainLayouts; track layout) {
          <div class="dashboard__main">
            <mrd-layout-section
              #sectionEl
              [accessControlEnabled]="accessControlEnabled"
              [items]="layout.items"
              [data]="dataRecord"
              [locale]="locale"
              [readOnly]="isViewer"
              [me]="me"
              [archetypes]="metadata.archetypes || []"
              (mrdNavigate)="onMrdNavigate($any($event))"
              (mrdDownload)="onMrdDownload($any($event))"
              (mrdLoadImage)="onMrdLoadImage(sectionEl, $any($event))"
              (mrdLoadObject)="onMrdLoadObject(sectionEl, $any($event))"
              (mrdAttachments)="onMrdAttachments($any($event))"
              (mrdLoadViewPage)="onMrdLoadViewPage(sectionEl, $any($event))"
              (mrdLoadViewAggregations)="onMrdLoadViewAggregations(sectionEl, $any($event))"
              (mrdLoadViewDistinct)="onMrdLoadViewDistinct(sectionEl, $any($event))"
              (mrdSearch)="onMrdSearch(sectionEl, $any($event))"
              (mrdViewAction)="onMrdViewAction($any($event))"
              (mrdUpdateObject)="onMrdUpdateObject($any($event))"
                    (mrdDeleteObject)="onMrdDeleteObject($any($event))"
              (mrdViewUpload)="onMrdViewUpload(sectionEl, $any($event))"
              (mrdCreateObject)="onMrdCreateObject(sectionEl, $any($event))"
              (mrdViewCheckCapabilities)="onMrdViewCheckCapabilities(sectionEl, $any($event))">
            </mrd-layout-section>
          </div>
        }
        @if (dataObject) {
          <ng-container *ngTemplateOutlet="dashboardButtons"></ng-container>
        }
        @if (tabPages.length > 0) {
          <div class="tabPage">
            @for (layout of tabPages; track layout; let i = $index) {
              <input type="radio" [id]="'tabPage' + i + '-' + tabGroupId" [name]="tabGroupId" [checked]="i === 0" class="tabPage__radio" (change)="onTabPageSelected(i)">
              <label [for]="'tabPage' + i + '-' + tabGroupId" class="tabPage__label">{{ layout.label }}</label>
              <div class="tabPage__content dashboard__tabPage">
                @if (visitedTabPages.has(i)) {
                  <mrd-layout-section
                    #sectionEl
                    [accessControlEnabled]="accessControlEnabled"
                    [items]="layout.items"
                    [data]="dataRecord"
                    [locale]="locale"
                    [readOnly]="isViewer"
                    [me]="me"
                    (mrdNavigate)="onMrdNavigate($any($event))"
                    (mrdDownload)="onMrdDownload($any($event))"
                    (mrdLoadImage)="onMrdLoadImage(sectionEl, $any($event))"
                    (mrdLoadObject)="onMrdLoadObject(sectionEl, $any($event))"
                    (mrdLoadViewPage)="onMrdLoadViewPage(sectionEl, $any($event))"
                    (mrdLoadViewAggregations)="onMrdLoadViewAggregations(sectionEl, $any($event))"
                    (mrdLoadViewDistinct)="onMrdLoadViewDistinct(sectionEl, $any($event))"
                    (mrdSearch)="onMrdSearch(sectionEl, $any($event))"
                    (mrdViewAction)="onMrdViewAction($any($event))"
                    (mrdUpdateObject)="onMrdUpdateObject($any($event))"
                    (mrdDeleteObject)="onMrdDeleteObject($any($event))"
                    (mrdViewUpload)="onMrdViewUpload(sectionEl, $any($event))"
                    (mrdCreateObject)="onMrdCreateObject(sectionEl, $any($event))"
                    (mrdViewCheckCapabilities)="onMrdViewCheckCapabilities(sectionEl, $any($event))">
                  </mrd-layout-section>
                }
              </div>
            }
          </div>
        }
      }
    }

    <ng-template #dashboardButtons>
      <div class="dashboard__buttons" #actionsContainer>
        @if (!isViewer && (!isSystemRoute || hasModifyAction) && canModify) {
          <button class="btn-icon" (click)="onEdit()" title="Bewerken">
            <svg class="icon"><use xlink:href="assets/sprites.svg#icon-pencil"></use></svg>
          </button>
        }
        @if (isAdmin) {
          <a class="btn-icon" [routerLink]="['/data', tenantCode, type, id, 'access']" title="Who can access this record">
            <svg class="icon"><use xlink:href="assets/sprites.svg#icon-info"></use></svg>
          </a>
        }
        @if (dropdownActions.length > 0) {
          <div class="btn-icon-dropdown">
            <button class="btn-icon" (click)="toggleActionsDropdown()" title="Acties">
              <svg class="icon"><use xlink:href="assets/sprites.svg#icon-ellipsis"></use></svg>
            </button>
            @if (actionsDropdownOpen) {
              <ul class="dropdown-menu">
                @for (action of dropdownActions; track action) {
                  <li>
                    <button class="dropdown-menu__item" (click)="onActionFromDropdown(action)">
                      {{ dropdownItemLabel(action) }}
                    </button>
                  </li>
                }
              </ul>
            }
          </div>
        }
      </div>
    </ng-template>

    @if (editingInOverlay) {
      <app-object-form
        [overlayHref]="dataObject?._links?._self?.href ?? null"
        (overlaySaved)="onOverlayEditSaved()"
        (overlayCancelled)="onOverlayEditCancelled()"
        (overlayDeleted)="onOverlayEditDeleted()">
      </app-object-form>
    }

    @if (openOverlayHref) {
      <div class="overlay-backdrop" (click)="closeOverlay()">
        <button class="btn-icon-overlay overlay-backdrop__close" (click)="$event.stopPropagation(); closeOverlay()" title="Sluiten">
          <svg class="icon"><use xlink:href="assets/sprites.svg#icon-cross"></use></svg>
        </button>
        @if (openOverlayListContext) {
          <button class="btn-icon-overlay overlay-backdrop__prev" [disabled]="!overlayNavLinks?.prev" (click)="$event.stopPropagation(); overlayPrev()" title="Vorige">
            <svg class="icon"><use xlink:href="assets/sprites.svg#icon-backward2"></use></svg>
          </button>
          <button class="btn-icon-overlay overlay-backdrop__next" [disabled]="!overlayNavLinks?.next" (click)="$event.stopPropagation(); overlayNext()" title="Volgende">
            <svg class="icon"><use xlink:href="assets/sprites.svg#icon-forward3"></use></svg>
          </button>
        }
        <div class="overlay-panel" (click)="$event.stopPropagation()">
          <app-dashboard
            [overlayHref]="openOverlayHref"
            (overlayNavigate)="onOverlayNavigate($event)"
            (overlayClose)="openOverlayHref = null; openOverlayListContext = null; overlayNavLinks = null">
          </app-dashboard>
        </div>
      </div>
    }

    @if (mergeOverlayOpen) {
      <div class="overlay-backdrop" (click)="closeMergeOverlay()">
        <button class="btn-icon-overlay overlay-backdrop__close" (click)="$event.stopPropagation(); closeMergeOverlay()" title="Sluiten">
          <svg class="icon"><use xlink:href="assets/sprites.svg#icon-cross"></use></svg>
        </button>
        <div class="overlay-panel" (click)="$event.stopPropagation()">
          <mrd-merge-view
            #mergeViewEl
            [locale]="locale"
            [objectClass]="type"
            [mostSignificantClass]="type"
            [fields]="mergeFields"
            [currentHref]="dataObject?._links?._self?.href ?? ''"
            [currentRecord]="dataRecord"
            [currentLabel]="dataObject?.name ?? ''"
            (mrdSearch)="onMrdMergeSearch($any($event))"
            (mrdMerge)="onMrdMerge($any($event))">
          </mrd-merge-view>
        </div>
      </div>
    }

    @if (deleteConfirmOpen) {
      <div class="overlay-backdrop" (click)="cancelDelete()">
        <div class="overlay-panel overlay-panel--confirm" (click)="$event.stopPropagation()">
          <h2 class="confirm-dialog__title">{{ 'confirm.delete_title' | translate }}</h2>
          <p class="confirm-dialog__body">
            <strong>{{ dataObject?.name }}</strong><br>
            {{ 'confirm.delete_body' | translate }}
          </p>
          <div class="confirm-dialog__actions">
            <a class="btn btn--basic" href="javascript:void(0)" (click)="cancelDelete()">
              {{ 'confirm.cancel' | translate }}
            </a>
            <a class="btn btn--danger" href="javascript:void(0)" (click)="confirmDelete()">
              {{ 'confirm.delete' | translate }}
            </a>
          </div>
        </div>
      </div>
    }
  </div>
}
